import TextField, { TextFieldSize } from '@/components/molecules/TextField';
import * as Yup from 'yup';
import validarDataNascimento from '@/validators/validarDataAniversário';

interface TextFieldDataNascimentoProps {
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $errors: FieldErrors<T>;
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $field: ControllerRenderProps<T, 'dataNascimento'>;
  inputSize?: TextFieldSize;
}

export const dataNascimentoMaskOptions = {
  mask: '__/__/____',
  replacement: { _: /\d/ },
};

export const dataNascimentoYupValidation = Yup.string()
  .required('Data de Nascimento é obrigatória')
  .test('dataNascimento-valida', 'Data de Nascimento inválida', (value) => {
    if (!value) return false;
    return validarDataNascimento(value);
  });

export default function TextFieldDataNascimento(
  props: TextFieldDataNascimentoProps,
) {
  const { $errors, $field, inputSize = 2 } = props;

  return (
    <TextField
      $size={inputSize}
      $variant="surface"
      $state="placeholder"
      $error={$errors.dataNascimento?.message ?? false}
      $label="Data de Nascimento"
      $focusRing={false}
      $placeholder="DD/MM/AAAA"
      $name="dataNascimento"
      $obrigatorio={true}
      $mask={dataNascimentoMaskOptions.mask}
      $inputProps={{
        value: $field.value,
        onBlur: $field.onBlur,
        onChange: $field.onChange,
      }}
    />
  );
}
